import { $http } from "@/utils/https";
import type { ActionContext } from "vuex";
import type { RootState } from "@/store";

interface State {
  guides: any;
  tickets: any;
}

const state: State = {
  guides: null,
  tickets: null,
};

const getters = {
  content: (state: State) => state.guides,
  tickets: (state: State) => state.tickets,
};

const actions = {
  FETCH_PRO_AGE_CODE: async ({ commit }: ActionContext<State, RootState>) => {
    try {
      const response = await $http.get("v1/pages/forum");
      commit("SET_FETCH_PRO_AGE_CODE_DATA", response.data.data);
      return response.data.data;
    } catch (e) {
      throw e;
    }
  },
  FETCH_TICKETS: async ({ commit }: ActionContext<State, RootState>) => {
    try {
      const response = await $http.get("v1/tickets");
      commit("SET_TICKETS_DATA", response.data.data);
      console.log(response.data.data);
      return response.data.data;
    } catch (e) {
      throw e;
    }
  },
};

const mutations = {
  SET_FETCH_PRO_AGE_CODE_DATA(state: State, payload: any) {
    state.guides = payload;
  },
  SET_TICKETS_DATA(state: State, payload: any) {
    state.tickets = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
